import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { JSX } from 'react';
import { cn } from '../../v2';
import { CircleSpinnerInline } from '../spinner';
interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  showing: boolean;
  isLoading?: boolean;
  onClick: (mouseEvent?: React.MouseEvent<HTMLButtonElement>) => unknown;
  testId?: string;
}
export default function ToggleDetailsButton(t0) {
  const $ = _c(15);
  const {
    showing,
    isLoading: t1,
    onClick,
    testId
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const t2 = !isLoading;
  let t3;
  if ($[0] !== isLoading || $[1] !== t2) {
    t3 = cn("box-border h-6 border-0 bg-transparent text-base outline-0", "text-steel-400 dark:text-steel-200 -ml-2 px-2 py-[2px]", "inline-flex items-center rounded-xs", {
      "pointer-events-none": isLoading,
      "hover:bg-steel-100 dark:hover:bg-steel-500": t2
    });
    $[0] = isLoading;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = showing ? "Hide details" : "Show details";
  let t5;
  if ($[3] !== isLoading || $[4] !== showing) {
    t5 = !isLoading && <div className={cn("ml-2 flex transform items-center outline-0", showing ? "rotate-0" : "rotate-180")}><Icon /></div>;
    $[3] = isLoading;
    $[4] = showing;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isLoading) {
    t6 = isLoading && <div className="ml-1"><CircleSpinnerInline /></div>;
    $[6] = isLoading;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== onClick || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== testId) {
    t7 = <button className={t3} type="button" onClick={onClick} data-testid={testId}>{t4}{" "}{t5}{t6}</button>;
    $[8] = onClick;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = testId;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
function Icon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M0 5.5L5 0.5L10 5.5H0Z" fill="currentColor" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}